/* Dazzuro — texture sélectionnée sur la fiche produit. */
(function () {
  'use strict';

  var frame = null;
  var libraryRetryTimer = null;
  var libraryRetryCount = 0;

  /* JSON.parse de toute la liste des variantes tournait a chaque mutation du
     DOM. On garde le resultat tant que le contenu du <script> n a pas change. */
  var cacheVariantes = { source: null, valeur: [] };

  function racines() {
    return document.querySelectorAll('[data-daz-texture-selected]');
  }

  function variantes() {
    var donnees = document.getElementById('variant-stock-data');
    if (!donnees) return [];

    var source = donnees.textContent || '';
    if (source === cacheVariantes.source) return cacheVariantes.valeur;

    var valeur = [];
    try {
      valeur = JSON.parse(source || '[]') || [];
    } catch (error) {
      valeur = [];
    }

    cacheVariantes = { source: source, valeur: valeur };
    return valeur;
  }

  function varianteCourante() {
    var input = document.querySelector('input[name="id"]');
    if (!input) return null;

    var liste = variantes();
    for (var i = 0; i < liste.length; i += 1) {
      if (String(liste[i].id) === String(input.value)) return liste[i];
    }

    return null;
  }

  function normaliser(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u200B-\u200D\uFEFF]/g, '')
      .toLowerCase()
      .replace(/[–—]/g, '-')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function trouverValeurOption(nom, slug) {
    var radio = document.querySelector('input[name="' + nom + '"]:checked');
    if (radio) return radio.value;

    var select = document.querySelector('select[name="' + nom + '"], select[name="options[' + nom + ']"]');
    if (select) return select.value;

    var picker = document.querySelector('[data-option-slug="' + slug + '"]');
    if (picker) {
      var choix = picker.querySelector('input:checked, option:checked');
      if (choix) return choix.value || choix.textContent;
    }

    return '';
  }

  function trouverTitreVariante() {
    var variante = varianteCourante();
    if (!variante || !variante.title) return '';
    return variante.title.split(' / ')[0].trim();
  }

  function trouverCouleurVariante() {
    var variante = varianteCourante();
    if (!variante || !variante.title) return '';
    return variante.title.split(' / ')[1] || '';
  }

  function nomCompletDe(item) {
    return [item.color, item.name].filter(Boolean).join(' ');
  }

  function estPersonnalisee(recherche) {
    return !recherche || recherche.indexOf('texture personnalisee') !== -1;
  }

  function paquet(groupe, item, libelle) {
    return {
      groupe: groupe,
      item: item,
      nomComplet: libelle || nomCompletDe(item) || item.name || item.color || '',
      image: item.swatch || item.pattern || ''
    };
  }

  /* Identification par un LIBELLE de coloris — « Vert Tilia 39 ».

     C est la voie la plus sure : ce libelle nomme un coloris et un seul. On
     tente d abord la correspondance exacte, puis le cas ou le libelle de la
     fiche porte un mot de plus que la bibliotheque (« Velours Tilia 39 » pour
     « Tilia 39 ») — il suffit alors qu il se TERMINE par le nom de l article. */
  /* Le mot « cuir » est ignore pour comparer des NOMS de coloris : la fiche
     Amalfi dit « Blanc Cambon 11 Granada Cognac », la bibliotheque
     « Cambon 11 Cuir Granada Cognac ». */
  function sansCuir(s) {
    return (' ' + s + ' ').replace(/ cuir(?= )/g, '').replace(/\s+/g, ' ').trim();
  }

  function parLibelle(libelle) {
    var recherche = sansCuir(normaliser(libelle));
    if (estPersonnalisee(recherche)) return null;

    var textures = window.TEXTURES || [];
    var g, i, item, candidats;

    for (g = 0; g < textures.length; g += 1) {
      var items = textures[g].items || [];
      for (i = 0; i < items.length; i += 1) {
        item = items[i];
        candidats = [nomCompletDe(item), item.name, item.color].map(function (c) { return sansCuir(normaliser(c)); }).filter(Boolean);
        if (candidats.indexOf(recherche) !== -1) return paquet(textures[g], item);
      }
    }

    /* Par la fin du libelle : le nom d article le PLUS LONG gagne. Le premier
       venu ne suffit pas — « Blanc Cambon 11 Granada Cognac » se termine aussi
       par « Granada Cognac », le cuir seul, qui affichait sa pastille et un
       titre « Cognac Granada Cognac » sur l Amalfi bicolore. */
    var meilleur = null, longueur = 0;
    for (g = 0; g < textures.length; g += 1) {
      var items2 = textures[g].items || [];
      for (i = 0; i < items2.length; i += 1) {
        item = items2[i];
        var nom = sansCuir(normaliser(item.name));
        if (nom && nom.length > longueur && (recherche === nom || recherche.slice(-(nom.length + 1)) === ' ' + nom)) {
          meilleur = paquet(textures[g], item);
          longueur = nom.length;
        }
      }
    }

    return meilleur;
  }

  /* Dernier recours : identification par la MATIERE — « Velours cotele ».

     Deux pieges que l ancienne version ne passait pas.

     1. Un libelle court avale un libelle long : « Element - Velours » etait
        retenu pour une recherche « velours gros cotele », simplement parce que
        « velours » y est contenu. Comme il arrivait avant Tilia dans la liste,
        c est lui qui gagnait. On note donc chaque groupe et on garde le PLUS
        SPECIFIQUE : egalite parfaite d abord, puis le suffixe le plus long.

     2. Le groupe retenu n avait pas le coloris demande, et la fonction rendait
        null au lieu de regarder le groupe suivant. On continue desormais. */
  function parMatiere(valeur, couleur) {
    var recherche = normaliser(valeur);
    if (estPersonnalisee(recherche)) return null;

    var rechercheCouleur = normaliser(couleur);
    var textures = window.TEXTURES || [];
    var meilleur = null;
    var meilleurScore = -1;

    for (var g = 0; g < textures.length; g += 1) {
      var groupe = textures[g];
      var libelle = normaliser(groupe.group);
      var suffixe = libelle.split(' - ').pop().trim();

      if (suffixe !== recherche && libelle.indexOf(recherche) === -1 && recherche.indexOf(suffixe) === -1) continue;

      var score = suffixe === recherche ? 1000 : suffixe.length;
      if (score <= meilleurScore) continue;

      var items = groupe.items || [];
      var choisi = null;

      if (rechercheCouleur && !estPersonnalisee(rechercheCouleur)) {
        for (var i = 0; i < items.length; i += 1) {
          var candidats = [nomCompletDe(items[i]), items[i].name, items[i].color].map(normaliser).filter(Boolean);
          if (candidats.indexOf(rechercheCouleur) !== -1) { choisi = items[i]; break; }
        }
        if (!choisi) continue;
      }

      if (!choisi) {
        for (var j = 0; j < items.length; j += 1) {
          if (items[j].swatch || items[j].pattern) { choisi = items[j]; break; }
        }
        choisi = choisi || items[0];
      }

      if (!choisi) continue;

      meilleurScore = score;
      meilleur = paquet(groupe, choisi, choisi === items[0] && !rechercheCouleur ? valeur : '');
    }

    return meilleur;
  }

  /* L option « Couleur » passe en premier : elle porte le coloris exact, alors
     que l option « Texture » ne porte souvent que la matiere — et sa
     formulation diverge de celle de la bibliotheque (une fiche annonce
     « Velours cotele » la ou la gamme s appelle « Tilia - Velours gros
     cotele »). Chercher par la matiere d abord faisait echouer la quasi-
     totalite des fiches. */
  function trouverTexture() {
    if (!window.TEXTURES || !window.TEXTURES.length) return null;

    var valeur = trouverValeurOption('Texture', 'texture') || trouverTitreVariante();
    var couleur = trouverValeurOption('Couleur', 'couleur') || trouverCouleurVariante();

    return parLibelle(couleur) || parLibelle(valeur) || parMatiere(valeur, couleur);
  }

  function afficher() {
    var texture = trouverTexture();

    /* Les racines sont relues a chaque passage. Elles etaient captees une
       seule fois au chargement : apres un re-rendu de la section produit
       (changement de variante en ajax, editeur de theme), le script gardait
       des noeuds detaches et le bloc restait vide a l ecran. */
    Array.prototype.forEach.call(racines(), function (root) {
      if (!texture) {
        /* Tant que la bibliotheque n est pas la, on n efface rien : le bloc
           garde ce qu il affiche et la prochaine passe le completera. */
        if (!window.TEXTURES || !window.TEXTURES.length) return;
        root.hidden = true;
        return;
      }

      var image = root.querySelector('[data-daz-texture-image]');
      var name = root.querySelector('[data-daz-texture-name]');
      var gamme = root.querySelector('[data-daz-texture-gamme]');
      var specs = root.querySelector('[data-daz-texture-specs]');
      var technique = root.querySelector('[data-daz-texture-technique]');
      var pdf = root.querySelector('[data-daz-texture-pdf]');
      var imageUrl = texture.image || texture.item.swatch || texture.item.pattern || '';

      root.hidden = false;
      if (image && imageUrl) {
        /* src="" resout vers l URL de la page : le navigateur telechargeait le
           HTML de la fiche a la place de la photo et affichait une image
           cassee. On ne pose l attribut que s il y a vraiment une adresse. */
        if (image.getAttribute('src') !== imageUrl) image.src = imageUrl;
        image.alt = texture.nomComplet;
      }
      if (name) name.textContent = texture.nomComplet;
      if (gamme) {
        gamme.textContent = [
          texture.groupe.gamme ? ((window.dazI18n && window.dazI18n.gamme) || 'Gamme') + ' ' + texture.groupe.gamme : '',
          texture.groupe.group || ''
        ].filter(Boolean).join(' - ');
      }
      if (specs) {
        specs.innerHTML = texture.groupe.specs_html || '';
        specs.hidden = !texture.groupe.specs_html;
      }
      if (technique) technique.hidden = !(texture.groupe.specs_html || texture.groupe.pdf);

      if (pdf && texture.groupe.pdf) {
        pdf.href = texture.groupe.pdf;
        pdf.hidden = false;
      } else if (pdf) {
        pdf.hidden = true;
      }
    });
  }

  /* Une seule passe par frame, quelles que soient les mutations recues. */
  function actualiser() {
    if (frame) return;
    frame = requestAnimationFrame(function () {
      frame = null;
      afficher();
    });
  }

  /* La bibliotheque de textures est un <script> inline rendu par la section
     texture-library (groupe du header). Elle est donc la avant ce fichier, qui
     est en defer — sauf quand l editeur de theme la re-rend, ou quand le bloc
     arrive apres coup. L ancienne version se contentait de deux essais a 150ms
     et 500ms puis abandonnait : passe ce delai, le bloc restait blanc. */
  function attendreBibliotheque() {
    if (window.TEXTURES && window.TEXTURES.length) {
      libraryRetryCount = 0;
      afficher();
      return;
    }

    if (libraryRetryCount >= 100) return;
    libraryRetryCount += 1;
    clearTimeout(libraryRetryTimer);
    libraryRetryTimer = setTimeout(attendreBibliotheque, 100);
  }

  function initialiser() {
    /* Plus de sortie anticipee sur une liste vide : le bloc peut etre injecte
       apres le chargement, l observateur pose plus bas le rattrapera. */
    attendreBibliotheque();

    document.addEventListener('change', function (event) {
      if (event.target.matches('input[name="Texture"], input[name="Couleur"], select[name="Texture"], select[name="options[Texture]"], select[name="Couleur"], select[name="options[Couleur]"], input[name="id"]')) {
        actualiser();
      }
    }, true);

    document.querySelectorAll('form').forEach(function (form) {
      form.addEventListener('variant:change', actualiser);
    });

    if (window.theme && theme.pubsub && theme.pubsub.subscribe && theme.pubsub.PUB_SUB_EVENTS) {
      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, actualiser);
    }

    var observer = new MutationObserver(actualiser);
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['checked', 'value'] });

    document.addEventListener('shopify:section:load', function () {
      libraryRetryCount = 0;
      attendreBibliotheque();
    });

    window.addEventListener('pageshow', actualiser);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiser);
  } else {
    initialiser();
  }
})();
